export default {
    TEMPLATE_FAILED: 'Failed to Load the template',
    TEMPLATE_HTML_FAILED: 'Failed to Load the html template',
    PROCESSING_FORM: 'Failed to process'
}
